export default {
  heading: {
    widgetName: "Tiktok-Value-Packs",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Snack & Cookies",
    headlineType: "h2",
    subHeadline: "",
    showMoreURL: "",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `Grocer Campaign | Grocer in Penang`,
      eventLabelCardClick: `Grocer in Penang | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `Grocer in Penang | headline | {{headline}}`,
      eventLabelView: `Grocer in Penang`,
    },
  },

  data: [
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/loong-nam.jpg",
      title: "Loong Nam 1928",
      subtitle: "Traditional handmade cookies at RM6.00 storewide",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-loong-nam-1928"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/uncle-lim.jpeg",
      title: "Uncle Lim",
      subtitle: "Authentic snacks from RM15.00",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-uncle-lim"
    },
    {
      primaryLabel: "",
      image: "https://www.airasia.com/aa/grocer/images/grocer-in-penang/everlyn-popcorn-shop.jpg",
      title: "Everlyn Popcorn",
      subtitle: "Handmade mushroom popcorn made with caramel and cheddar cheese",
      star: "",
      originalprice: "",
      price: "",
      priceDisclaimer: "",
      cta: "",
      currencyCode: "MYR",
      url: "https://www.airasia.com/grocer/my/en/merchant/penang-delivery-everlyn-popcorn-shop"
    }
  ],
}
